import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input }                    from "semantic-ui-react";
import GetCustomersHaveEmail        from "../../../../../application/usecase/customer/GetCustomersHaveEmail";
import CustomerSearchValue          from "../../../../../domain/customer/criteria/CustomerSearchValue";
import Customers                    from "../../../../../domain/customer/Customers";
import CurrentPage                  from "../../../../../domain/fundamentals/pagination/CurrentPage";
import { ResKaState }               from "../../../../../index";

const MailGroupCustomersSearchBox: FC = () => {
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const current: CurrentPage = customers.pagination.current;
  const search: CustomerSearchValue = customers.search;
  const getCustomersHaveEmail: GetCustomersHaveEmail = new GetCustomersHaveEmail(useDispatch());
  return (
    <>
      <Input
        icon="search"
        placeholder="顧客検索"
        defaultValue={ search.value }
        onChange={ (event, data) => setTimeout(() => getCustomersHaveEmail.execute(current, new CustomerSearchValue(data.value)), 500) }
      />
    </>
  );
};

export default MailGroupCustomersSearchBox;
